module.exports = __webpack_public_path__ + "static/media/attachHandle.33dd747d.png";